var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ConstructionCarpenterRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIaEfMrIF9f9GlTtBFcFna",
    x1: 22.548,
    x2: 25.084,
    y1: 30.982,
    y2: 50.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323538"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eIaEfMrIF9f9GlTtBFcFna)",
    d: "M7,46V36h32c1.105,0,2,0.895,2,2v6c0,1.105-0.895,2-2,2H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fac500",
    d: "M17,36L7,46V4c0-1.105,0.895-2,2-2h6c1.105,0,2,0.895,2,2V36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M9,27H7v-2h2c0.552,0,1,0.448,1,1S9.552,27,9,27z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M10,18c0-0.552-0.448-1-1-1H7v2h2C9.552,19,10,18.552,10,18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M7,15h4c0.552,0,1-0.448,1-1s-0.448-1-1-1H7V15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M10,10c0-0.552-0.448-1-1-1H7v2h2C9.552,11,10,10.552,10,10z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M7,7h4c0.552,0,1-0.448,1-1s-0.448-1-1-1H7V7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M10,34c0-0.552-0.448-1-1-1H7v2h2C9.552,35,10,34.552,10,34z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M11,21H7v2h4c0.552,0,1-0.448,1-1S11.552,21,11,21z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M11,29H7v2h4c0.552,0,1-0.448,1-1S11.552,29,11,29z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#c98e00",
    d: "M11,37H7v2h4c0.552,0,1-0.448,1-1S11.552,37,11,37z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 43,
    r: 1,
    fill: "#dbdbdb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 43,
    r: 1,
    fill: "#dbdbdb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 39,
    r: 1,
    fill: "#dbdbdb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ConstructionCarpenterRuler);
export default __webpack_public_path__ + "static/media/icons8-construction-carpenter-ruler.55a109ac65bb3280b5a41ea4bfe4ec05.svg";
export { ForwardRef as ReactComponent };